import React, { Component } from 'react'
import { Tabs, Row, Col, Form, Input, Button, Spin, Icon, Tooltip, Progress, InputNumber, Upload, message, Modal, Tag, notification, Select } from 'antd';
const { TextArea } = Input;

class MainCommentForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      maincomment: ''
    }
  }

  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  sendMainComment = (e) => {
    e.preventDefault()
    const { maincomment } = this.state
    const { postId, profile } = this.props

    this.props.form.validateFields((err) => {
      if (!err) {
        let commentDetails = {
          maincomment,
          userId: profile.uid,
          fullName: profile.fullName,
          postId
        }
        this.props.sendComment(commentDetails)
        this.props.form.resetFields()
        // this.props.getCommentsAgain()
      }
    });
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div>
        <Form onSubmit={this.sendMainComment}>
          <Form.Item>
            {getFieldDecorator('comment', {
              rules: [
                { required: true, message: 'Please inout a comment' }
              ]
            })(
              <TextArea name="maincomment" onChange={this.handleInputChange} rows={4} />
            )}
          </Form.Item>
          <Form.Item>
            <Button type="primary" className="send-btn" htmlType="submit">
              Send
              <i className="fas fa-paper-plane"></i>
            </Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const WrappedMainCommentForm = Form.create()(MainCommentForm);

export default WrappedMainCommentForm